import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import { Card } from "react-bootstrap";
import { BiMinus, BiPlus, BiTrash } from "react-icons/bi";
import "./ProductCard.scss";
import WebInfoContext from "../../../../context/WebInfo/WebInfoContext.ts";

import { pathMaker } from "../../../../utils/helperFunctions";
import placeholder from "../../../../assets/images/placeholder-image.png";
import CardItemContext from "../../../../context/CardItem/CardItemContext";
import { showSwalQuestion } from "../../../../utils/swal";
import { OptionItemAndValue } from "../../../admin-panel/product-management/insert-product/InventoryItemProduct";
import { calculateProductPrice } from "../../../../utils/Helper.ts";

const ProductCard = ({ item }) => {
  const { setBasketData } = useContext(WebInfoContext);
  const { changeItemCount } = useContext(CardItemContext);

  useEffect(() => {
    console.log("test: ", item);
  }, []);
  console.log(item);

  //کارد نمایش هر محصول که شامل عکس، نام محصول و ... میباشد
  return (
    <Card className="col-11 d-flex flex-row productCard">
      {item?.file[0].url != "" ? ( //shFazeli 1402/04/25 شرط برای وقتی که محصول عکس نداشت
        <Card.Img
          variant="top"
          src={pathMaker(item?.file[0]?.url)}
          alt={item.title}
          style={{ width: "80px", height: "80px" }}
        />
      ) : (
        <Card.Img
          variant="top"
          src={placeholder}
          alt={item.title}
          style={{ width: "80px", height: "80px", objectFit: "contain" }}
        />
      )}
      <Card.Body style={{ fontSize: "14px", padding: "8px", width: 100 }}>
        <Card.Title
          style={{
            fontWeight: "bold",
            fontSize: "inherit",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {item.title}
          <span
            className="trash-icon"
            onClick={() => {
              showSwalQuestion("آیا از حذف این آیتم مطمئن هستید؟").then(
                (result) => {
                  if (result.isConfirmed) {
                    changeItemCount("remove", item.product_price_id);
                  }
                }
              );
            }}
          >
            <BiTrash />
          </span>
        </Card.Title>
        <Card.Text style={{ fontSize: "inherit", marginBottom: "5px" }}>
          {item?.features?.length > 0 ? (
            <div className="d-flex flex-wrap">
              {item?.features?.map((v, i) => (
                <OptionItemAndValue
                  item={v}
                  color="navy"
                  bgColor="rgb(238, 241, 255)"
                />
              ))}
            </div>
          ) : (
            ""
          )}
        </Card.Text>
        <div className="d-flex flex-row justify-content-between align-items-center">
          {item.main_discount == "0" ? (
            <Card.Text className="col-7 mr-b-0" style={{ fontSize: "inherit" }}>
              {calculateProductPrice(item)} تومان
            </Card.Text>
          ) : (
            <div className="col-7 d-flex flex-column">
              <span className="text-secondary text-decoration-line-through font-12-500">
                {calculateProductPrice(item, "discount").mainPrice} تومان
              </span>
              <span className="">
                {calculateProductPrice(item, "discount").currentPrice} تومان
              </span>
            </div>
          )}

          {/* hosseini 1402/05/12 نمایش تخفیف اعمال شد*/}

          <div className="input-group miniBasketCounter">
            <div
              className={`${
                // item.number === item.stock
                item.is_available != 1 ? "styles__counter-icons-disabled " : ""
              }cursor-pointer`}
              onClick={(e) =>
                // item.number !== item.stock ? handleIncrease(item.id) : ""
                // item.number !== item.stock
                //   ?
                item.is_available == 1 //shFazeli 1402/04/26
                  ? changeItemCount("add", item.product_price_id)
                  : ""
              }
            >
              <BiPlus />
            </div>
            <div className="styles__counter-value text-center">
              <span
                className="styles__counter-input"
                defaultValue={item.number}
                onChange={(e) =>
                  setBasketData((prev) => {
                    return prev.map((val) => {
                      if (val.id === item.product_price_id) {
                        return {
                          ...val,
                          number: +e.target.value, // Update the number value as needed
                        };
                      }
                      return val;
                    });
                  })
                }
                // value={item.itemcount}
              >
                {item.itemcount}
              </span>
            </div>
            <div
              className={`${
                item.is_available != 1 ? "styles__counter-icons-disabled " : ""
              }cursor-pointer`}
              onClick={(e) =>
                // item.itemcount !== 1 ? handleDecrease(item.id) : ""
                // item.itemcount !== 1
                item.is_available == 1 //shFazeli 1402/04/26
                  ? changeItemCount("reduce", item.product_price_id)
                  : ""
              }
            >
              <BiMinus />
            </div>
          </div>
        </div>
        {item.is_available != 1 && (
          <div style={{ fontSize: 12, color: "red" }}>
            موجودی این کالا به پایان رسیده است.
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ProductCard;
